export const verificationEndpoints = {
  verifyTaxId: { method: 'post', path: '/tax-id' },
  verifyTaxIdDraft: { method: 'post', path: '/tax-id/draft' },
  getVerificationById: { method: 'get', path: '/{id}' },
  listVerificationsBySubject: { method: 'get', path: '/by-subject/{subjectKind}/{subjectId}' },
} as const
